 
function handleBuyNowClick(event) {
    if (event.target.classList.contains('button-buy-now')) {
        const variantId = event.target.getAttribute('data-variant-id'); 
        
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: {
                    [variantId]: 1  
                }
            })
        })
        .then(response => response.json())
        .then(cart => {
            window.location.href = '/checkout';   
        });
    }
} 
document.addEventListener('DOMContentLoaded', function() { 
    document.addEventListener('click', handleBuyNowClick); 
    const buyNowButtons = document.querySelectorAll('.button-buy-now'); 
}); 
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
            const buyNowButtons = document.querySelectorAll('.button-buy-now'); 
        }
    });
}); 
observer.observe(document.body, {
    childList: true,
    subtree: true
});